import { P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${themeStyle.varBackgroundAlt};
  transition: box-shadow 0.3s;
  box-shadow: ${({ isActive }) =>
    isActive ? themeStyle.varShadowSmallFocus : 'unset'};
  border-radius: ${themeStyle.radiusMedium};
`;

// P2 on desktop, P3 on mobile
export const Text = styled(P3)`
  padding: 0 16px;
  margin-bottom: 8px;
  margin-top: 12px;

  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize14};
    line-height: 22px;
  }

  p {
    margin: 0px;
  }
`;
